import { Loader2, RefreshCw } from "lucide-react";
import { type FormEvent, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useResendVerification } from "@/features/auth/hooks/use-resend-verification";

const CONFIRMATION =
	"Se houver uma conta pendente com este e-mail, enviamos um novo link de confirmação.";

interface ResendVerificationActionProps {
	email?: string;
	label?: string;
}

export function ResendVerificationAction({
	email,
	label = "Reenviar e-mail de confirmação",
}: ResendVerificationActionProps) {
	const resend = useResendVerification();
	const [typedEmail, setTypedEmail] = useState("");

	const address = email ?? typedEmail;

	function handleSubmit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		if (!address) return;
		resend.mutate(address);
	}

	if (resend.isSuccess) {
		return <p className="resend-verification__message">{CONFIRMATION}</p>;
	}

	return (
		<form className="resend-verification" onSubmit={handleSubmit}>
			{!email && (
				<div className="form-group">
					<Label htmlFor="resend-email">E-mail cadastrado</Label>
					<Input
						id="resend-email"
						type="email"
						required
						placeholder="voce@empresa.com.br"
						autoComplete="email"
						value={typedEmail}
						onChange={(event) => setTypedEmail(event.target.value)}
					/>
				</div>
			)}

			<Button
				type="submit"
				className="resend-verification__submit"
				disabled={resend.isPending}
			>
				{resend.isPending ? (
					<Loader2 className="auth-spinner" />
				) : (
					<RefreshCw />
				)}
				{label}
			</Button>

			{resend.isError && (
				<p className="form-error">
					Não foi possível reenviar o e-mail. Tente novamente.
				</p>
			)}
		</form>
	);
}
